import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SessionStorageService {

    setItem(key: string, value: string): void {
        try {
            sessionStorage.setItem(key, value);
        } catch (error) {
            console.error('Error saving to sessionStorage', error);
        }
    }

    getItem(key: string): string | null {
        try {
            return sessionStorage.getItem(key);
        } catch (error) {
            console.error('Error reading from sessionStorage', error);
            return null;
        }
    }

    removeItem(key: string): void {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            console.error('Error removing from sessionStorage', error);
        }
    }

    clear(): void {
        try {
            sessionStorage.clear();
        } catch (error) {
            console.error('Error clearing sessionStorage', error);
        }
    }

    hasItem(key: string): boolean {
        return this.getItem(key) !== null;
    }

    getObject<T>(key: string): T | null {
        const item = this.getItem(key);
        if (!item) return null;

        try {
            return JSON.parse(item) as T;
        } catch (error) {
            console.error('Error parsing JSON from sessionStorage', error);
            return null;
        }
    }

    setObject<T>(key: string, value: T): void {
        try {
            const serialized = JSON.stringify(value);
            this.setItem(key, serialized);
        } catch (error) {
            console.error('Error stringifying object for sessionStorage', error);
        }
    }
}
